import { CATEGORIES_ENUMS } from "constants/navigation/categories";
import { useParams } from "react-router-dom";
import { Languages } from "types/localization";

const CATEGORIES_ENUMS_VALUES = Object.values(CATEGORIES_ENUMS) as string[];
const LANGUAGES = Object.values(Languages) as string[];

interface IUseGetParam {
  lang: string;
  category: string;
  game: string;
}

const INIT_PARAMS: IUseGetParam = {
  lang: "",
  category: "",
  game: "",
};

export const useGetParam = () => {
  const urlParams = useParams();
  if (Object.values(urlParams).length) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const params: IUseGetParam = Object.values(urlParams).reduce(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (prev: IUseGetParam, curr: string) => {
        if (CATEGORIES_ENUMS_VALUES.includes(curr)) {
          // eslint-disable-next-line no-param-reassign
          prev.category = curr;
          return prev;
        }
        if (LANGUAGES.includes(curr)) {
          // eslint-disable-next-line no-param-reassign
          prev.lang = curr;
          return prev;
        }
        // eslint-disable-next-line no-param-reassign
        prev.game = curr;
        return prev;
      },
      { ...INIT_PARAMS },
    );
    return params;
  }
  return INIT_PARAMS;
};
